import React from "react";
import Navbar from "../../components/Navbar";

const Menu = () => {
  return (
    <div>
      <Navbar />
    </div>
  );
};

export default Menu;
